/**
 * Feature → User-Manual slug map (TRIL-423 / TRIL-424).
 *
 * Single source of truth so a page's `<ManualLink section="…" />` can never
 * drift from its manual page: components reference a semantic FEATURE key here,
 * and the actual `/readme/<slug>` target lives only in this map. Each value is
 * typed as a `ManualSlug`, so a typo that doesn't match a registered section
 * fails `tsc` (the unit test is the runtime backstop).
 *
 * (Every value must be a registered section in `pages/Manual/manualRegistry.ts`.)
 */
import type { ManualSlug } from '../pages/Manual/manualRegistry';

export const FEATURE_MANUAL_SLUG = {
  about: 'about',
  vouching: 'vouching',
  'story-analysis': 'story-analysis',
  reputation: 'reputation',
  moderation: 'moderation',
} as const satisfies Record<string, ManualSlug>;

export type ManualFeatureKey = keyof typeof FEATURE_MANUAL_SLUG;
